import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import axios from "axios";
import { config } from '../utils/constants';
import { Link, useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import Breadcrumbs from '../components/breadcrumbs';

// Importing images
import ProductImage1 from "../assets/images/blog/product-min-01.jpg";
import ProductImage2 from "../assets/images/blog/product-min-02.jpg";
import ProductImage3 from "../assets/images/blog/product-min-03.jpg";
import BackgroundImage from "../assets/images/blog/herbs.jpeg";

const Blog = () => {
    var REACT_APP_API_URL = config.url.REACT_APP_API_URL;
    var REACT_API_IMAGE_URL = config.url.REACT_API_IMAGE_URL;
    
    const [blogData, setBlogData] = useState([]);
    const [last4BlogData, setLast4BlogData] = useState([]);
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const blogsPerPage = 4; // Show only 4 blogs per page

    useEffect(() => {
        axios
            .get(`${REACT_APP_API_URL}/blogs/`)
            .then((res) => {
                setBlogData(res.data['blogs']);
                setLast4BlogData(res.data['last_4_blogs']);
            })
            .catch((err) => {
                console.error("Error fetching blogs:", err);
            });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);

    // Calculate pagination indexes
    const totalPages = Math.ceil(blogData.length / blogsPerPage);
    const indexOfLastBlog = currentPage * blogsPerPage;
    const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
    const currentBlogs = blogData.slice(indexOfFirstBlog, indexOfLastBlog);

    // Pagination handlers
    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div>
            <Layout>
                {/* Title Section */}
                <section
                    className="bg-img1 txt-center p-lr-15 p-tb-92"
                    style={{ backgroundImage: `url(${BackgroundImage})` }}
                >
                    <h2 className="ltext-105 cl0 txt-center">Blog</h2>
                </section>

                <div className="container  p-b-10">
                <Breadcrumbs />
                </div>

                {/* Content Section */}
                <section className="full-page-section bg0 p-t-40 p-b-60">
                    <div className="container">
                        <div className="row">
                            {/* Blog Posts */}
                            <div className="col-md-8 col-lg-9 p-b-80">
                                <div className="p-r-45 p-r-0-lg">
                                    {currentBlogs.map((post) => (
                                        <div key={post.id} className="p-b-63">
                                            <div
                                                onClick={() => navigate(`/blog/blog-detail/?title=${post.slug}`)}
                                                style={{ cursor: "pointer" }}
                                                className="hov-img0 how-pos5-parent"
                                            >
                                                <img src={`${REACT_API_IMAGE_URL}${post.lead_image}`} alt={`Blog ${post.id}`} />
                                            </div>
                                            <div className="p-t-32">
                                                <h4 className="p-b-15">
                                                    <div
                                                        className="ltext-108 cl2 hov-cl1 trans-04"
                                                        onClick={() => navigate(`/blog/blog-detail/?title=${post.slug}`)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        {post.title}
                                                    </div>
                                                </h4>
                                                <span className="stext-117 cl6">{parse(post.teaser_text)}</span>
                                                <div className="flex-w flex-sb-m p-t-18">
                                                    <span className="flex-w flex-m stext-111 cl2 p-r-30 m-tb-10">
                                                        <span>
                                                            <span className="cl4">By</span> Admin
                                                            <span className="cl12 m-l-4 m-r-6">|</span>
                                                        </span>
                                                        <span>Comments</span>
                                                    </span>
                                                    <div
                                                        className="stext-101 cl2 hov-cl1 trans-04 m-tb-10"
                                                        onClick={() => navigate(`/blog/blog-detail/?title=${post.slug}`)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        Continue Reading
                                                        <i className="fa fa-long-arrow-right m-l-9"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {/* Pagination */}
                                    <div className="flex-l-m flex-w w-full p-t-10 m-lr--7">
                                        <button
                                            className={`flex-c-m how-pagination1 trans-04 m-all-7 ${currentPage === 1 ? 'disabled' : ''}`}
                                            onClick={prevPage}
                                            disabled={currentPage === 1}
                                        >
                                            Prev
                                        </button>

                                        {[...Array(totalPages)].map((_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => setCurrentPage(index + 1)}
                                                className={`flex-c-m how-pagination1 trans-04 m-all-7 ${currentPage === index + 1 ? 'active-pagination1' : ''}`}
                                            >
                                                {index + 1}
                                            </button>
                                        ))}

                                        <button
                                            className={`flex-c-m how-pagination1 trans-04 m-all-7 ${currentPage === totalPages ? 'disabled' : ''}`}
                                            onClick={nextPage}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Sidebar */}
                            <div className="col-md-4 col-lg-3 p-b-80">
                                <div className="side-menu">
                                    {/* Recent Posts */}
                                    <div className="p-t-55">
                                        <h4 className="mtext-112 cl2 p-b-33">Recent Posts</h4>
                                        <ul>
                                            {last4BlogData.map((blog) => (
                                                <li className="bor18" key={blog.id}>
                                                    <Link
                                                        to={`/blog/blog-detail?title=${blog.slug}`}
                                                        className="dis-block stext-115 cl6 hov-cl1 trans-04 p-tb-8 p-lr-4"
                                                    >
                                                        {blog.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* Tags */}
                                    <div className="p-t-50">
                                        <h4 className="mtext-112 cl2 p-b-27">Tags</h4>
                                        <div className="flex-w m-r--5">
                                            {blogData.slice(0, 4).flatMap((blog) =>
                                                blog.meta_keywords.split(",").map((tag, index) => (
                                                    <a
                                                        key={`${blog.id}-${index}`} 
                                                        href="/"
                                                        className="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5"
                                                    >
                                                        {tag.trim()}
                                                    </a>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    );
};

export default Blog;
